import { PARKING_FEATURE_TYPE } from "@mozioinc/query";
import { ReactComponent as Open24Svg } from "./assets/24-7.svg";
import { ReactComponent as CctvSvg } from "./assets/cctv.svg";
import { ReactComponent as FreeCancelationSvg } from "./assets/free-cancelation.svg";
import { ReactComponent as IndoorSvg } from "./assets/indoor.svg";
import { ReactComponent as KeyDropOffSvg } from "./assets/key-drop-off.svg";
import { ReactComponent as OutdoorSvg } from "./assets/outdoor.svg";
import { ReactComponent as WheelChairSvg } from "./assets/wheelchair-accessible.svg";
import type { ParkingFeatureType } from "@mozioinc/query";

type ParkingFeatureIconProps = {
  type: ParkingFeatureType;
  className?: string;
};

const featureIconMap = {
  [PARKING_FEATURE_TYPE.FREE_CANCELLATION]: FreeCancelationSvg,
  [PARKING_FEATURE_TYPE.COVERED]: IndoorSvg,
  [PARKING_FEATURE_TYPE.UNCOVERED]: OutdoorSvg,
  [PARKING_FEATURE_TYPE.ACCESSIBLE]: WheelChairSvg,
  [PARKING_FEATURE_TYPE.CCTV]: CctvSvg,
  [PARKING_FEATURE_TYPE.KEY_DROP_OFF]: KeyDropOffSvg,
  [PARKING_FEATURE_TYPE.OPEN_24_7]: Open24Svg,
};

export const ParkingFeatureIcon = ({
  type,
  className,
}: ParkingFeatureIconProps) => {
  const Icon = featureIconMap[type];

  return <Icon className={className} />;
};
